import React, { useState, useRef, useEffect } from 'react';
import { Send, Sparkles, X, Loader2 } from 'lucide-react';
import './ChatBox.css';

const ChatBox = ({ messages, onSend, onClose }) => {
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    return () => {
      const top = document.body.style.top;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (top) window.scrollTo(0, parseInt(top || '0') * -1);
    };
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    if (!sending) inputRef.current?.focus();
  }, [messages, sending]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim() || sending) return;
    const text = input.trim();
    setInput('');
    setSending(true);
    await onSend(text);
    setSending(false);
  };

  return (
    <div className="chatbox-overlay">
      <div className="chatbox">
        <div className="chatbox__header">
          <div className="chatbox__header-left">
            <div className="chatbox__header-icon">
              <Sparkles size={18} />
            </div>
            <div>
              <h3 className="chatbox__header-title">işBulsun AI</h3>
              <p className="chatbox__header-status">Size en uygun ilanları bulmak için birkaç bilgiye ihtiyacım var</p>
            </div>
          </div>
          <button className="chatbox__close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="chatbox__messages">
          {messages.map((msg, i) => (
            <div key={i} className={`chatbox__msg chatbox__msg--${msg.role}`}>
              {msg.role === 'ai' && (
                <div className="chatbox__msg-label">
                  <Sparkles size={12} />
                  işBulsun AI
                </div>
              )}
              <div className="chatbox__msg-bubble">
                {msg.typing ? (
                  <div className="chatbox__typing">
                    <span></span><span></span><span></span>
                  </div>
                ) : (
                  <p>{msg.text}</p>
                )}
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        <form className="chatbox__input-area" onSubmit={handleSubmit}>
          <div className="chatbox__input-wrap">
            <input
              ref={inputRef}
              type="text"
              className="chatbox__input"
              placeholder="Cevabınızı yazın..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              disabled={sending}
            />
            <button type="submit" className="chatbox__send" disabled={sending || !input.trim()}>
              {sending ? <Loader2 size={18} className="chatbox__spinner" /> : <Send size={18} />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChatBox;
